module.exports = __webpack_public_path__ + "img/josh-smile-lr.d93f5846.jpg";